import { createSlice } from '@reduxjs/toolkit';
// import { validateNationalIdNumberFormat } from '../../library/national-id';

const initialState = {
    meta: {
        pageNumber: 1,
        pageSize: 20,
        itemTotal: 0
    },
    list: [],
    reports: [],
    selectedLead: {
        lead: {
            _id: undefined
        },
        files: []
    },
    leadAdded: false,
    leadUpdated: false,
    leadRemoved: false,
    leadsFields: [],
    leadDeals: [],
};

const leadsSlice = createSlice({
    name: 'leads',
    initialState,
    reducers: {
        getLeads(state, action) {
            state.list = action.payload.leads;
            state.meta = action.payload.meta
        },
        getLeadsReport(state, action) {
            state.reports = action.payload;
        },
        getLeadsById(state, action) {
            state.selectedLead = action.payload;
        },
        addLeads(state, action) {
            state.leadAdded = true
        },
        updateLeads(state, action) {
            state.leadUpdated = true
        },
        removeLeads(state, action) {
            state.leadRemoved = true
        },
        getLeadFields(state, action) {
            state.leadsFields = action.payload;
        },
        updateLeadFields(state, action) {
            state.leadUpdated = true
        },
        getLeadDeals(state, action) {
            state.leadDeals = action.payload;
        },
        reset: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const leadsActions = leadsSlice.actions;
export default leadsSlice;
